/** On-screen copy shown in the Søppelbilen game (Norwegian). */

/** "Good job!" — shown right after the load is dumped. */
export const GOOD_JOB_TEXT = 'Bra jobba!';

/** Short spoken praise after each bin, picked in turn so it doesn't repeat back to back. */
export const BIN_PRAISE = ['Flott!', 'Supert!', 'Kjempebra!', 'Så flink du er!', 'Hurra!'];

export function binPraise(index: number): string {
  return BIN_PRAISE[((index % BIN_PRAISE.length) + BIN_PRAISE.length) % BIN_PRAISE.length];
}
